import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  image: {
    file: null,
    imageData: null,
    URL: null,
    name: null,
  },
  response: null,
  loadingState: false,
};

const slice = createSlice({
  name: "image",
  initialState,
  reducers: {
    setImage: (state, { payload }) => {
      state.image = payload;
    },
    setResponse: (state, { payload }) => {
      state.response = payload;
    },
    setLoadingState: (state, { payload }) => {
      state.loadingState = payload;
    },
  },
});

export const { setImage, setResponse, setLoadingState } = slice.actions;

export const image = slice.reducer;
